import './styles/fonts.css';
import './styles/main.css';
import './styles/header.css';
import './styles/footer.css';
import './styles/home.css';
import './styles/pages.css';
import './styles/preloader.css';

import { initRouter } from './router.js';
import { initializeSketch, setSketchTheme } from './p5Sketch.js';
import { borderRadGen } from './borderRadGen.js';
import { applyDailyLogo } from './dailyLogo.js';

applyDailyLogo();

// Apply saved theme before anything renders (inline <script> in index.html also fires earlier)
const savedTheme = localStorage.getItem('theme') || 'dark';
document.documentElement.dataset.theme = savedTheme;

const preloader = document.getElementById('preloader');

Promise.race([
  Promise.all([document.fonts ? document.fonts.ready : Promise.resolve(), initRouter()]),
  new Promise(resolve => setTimeout(resolve, 5000)), // fallback so a stalled font/network request can't strand users behind the overlay
]).then(() => {
  preloader.classList.add('loaded');
  preloader.addEventListener('transitionend', () => preloader.remove(), { once: true });
});

borderRadGen();

// ─── Clock ───
function updateClock() {
  const now = new Date();
  const timeStr = now.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    timeZone: 'America/New_York',
  });
  const nyHour = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' })).getHours();
  const dayState = nyHour >= 6 && nyHour < 18 ? 'Day' : 'Night';
  const dayStatus = document.getElementById('dayState');
  const headerTime = document.getElementById('headerTime');
  if (dayStatus) dayStatus.textContent = dayState;
  if (headerTime) headerTime.textContent = timeStr;
}

updateClock();
setInterval(updateClock, 1000);

// ─── Theme toggle ───
function applyTheme(theme) {
  const container = document.getElementById('container');
  if (container) container.style.opacity = '0';
  requestAnimationFrame(() => {
    document.documentElement.dataset.theme = theme;
    setSketchTheme(theme);
    localStorage.setItem('theme', theme);
    const btn = document.getElementById('themeToggle');
    if (btn) btn.setAttribute('aria-label', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
    const themeName = document.getElementById('themeName');
    if (themeName) themeName.textContent = theme === 'dark' ? 'Light - ' : 'Dark - ';
    requestAnimationFrame(() => {
      if (container) container.style.opacity = '1';
    });
    
  });
}

document.getElementById('themeToggle')?.addEventListener('click', () => {
  const current = document.documentElement.dataset.theme || 'dark';
  applyTheme(current === 'dark' ? 'light' : 'dark');
});

// ─── Hamburger nav ───
const navToggle = document.getElementById('navToggle');
const header = document.getElementById('header');

navToggle?.addEventListener('click', () => {
  const isOpen = header.classList.toggle('nav-open');
  navToggle.setAttribute('aria-expanded', String(isOpen));
  navToggle.setAttribute('aria-label', isOpen ? 'Close navigation menu' : 'Open navigation menu');
});

document.querySelectorAll('.nav-link a[data-link]').forEach(link => {
  link.addEventListener('click', () => {
    header.classList.remove('nav-open');
    navToggle?.setAttribute('aria-expanded', 'false');
  });
});

// ─── p5 sketch (skip on mobile) ───
const isMobile = window.matchMedia('(max-width: 767px)').matches;

function startSketch() {
  initializeSketch(isMobile);
  setSketchTheme(savedTheme);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => setTimeout(startSketch, 100));
} else {
  setTimeout(startSketch, 100);
}
